/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type BaggageCategory = typeof BaggageCategory[keyof typeof BaggageCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaggageCategory = {
  PersonalItem: 'PersonalItem',
  CabinBaggage: 'CabinBaggage',
  CheckedBaggage: 'CheckedBaggage',
  SpecialBaggage: 'SpecialBaggage',
} as const;
